import {
	containerNextSX,
	containerTitleNextSX,
	listItemSX,
	subtitleSX,
	titleSX,
} from '@/components/blocks/DpLibrary/DpNextBenefit/style/main';
import { Box, List, ListItem, Stack, Typography } from '@mui/material';

export const DpRewardsCrown = ({ fill, background }: any) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="13.564"
		height="13.564"
		viewBox="0 0 13.564 13.564"
	>
		<g id="Grupo_1576" data-name="Grupo 1576" transform="translate(-7465.407 -7682.708)">
			<g id="Grupo_1518" data-name="Grupo 1518" transform="translate(7465.407 7682.708)">
				<path
					id="iconmonstr-star-6"
					d="M6.782,0a6.782,6.782,0,1,0,6.782,6.782A6.782,6.782,0,0,0,6.782,0ZM9.227,10.323,6.782,9.016,4.337,10.323l.488-2.729-2-1.921,2.747-.379L6.782,2.8l1.209,2.5,2.747.379-2,1.922.488,2.729Z"
					transform="translate(0 0)"
					fill={background ? background : '#333'}
				/>
				<rect
					id="Rectángulo_5242"
					data-name="Rectángulo 5242"
					width="8.777"
					height="8.777"
					rx="4.388"
					transform="translate(2.867 2.626)"
					fill={background ? background : '#333'}
				/>
			</g>
			<path
				id="iconmonstr-crown-1"
				d="M.994,6.64,0,3.326,2.354,4.651,3.977,2,5.6,4.651,7.954,3.326,6.96,6.64Zm0,.663V8.628H6.96V7.3Z"
				transform="translate(7468.211 7684.176)"
				fill={fill ? fill : '#fbfbfb'}
			/>
		</g>
	</svg>
);

export const DpNextBenefit = ({
	title,
	subtitle1,
	subtitle2,
	subtitle3,
}: {
	title: string;
	subtitle1: string;
	subtitle2: string;
	subtitle3: string;
}) => {
	const subtitles = [subtitle1, subtitle2, subtitle3].filter(Boolean);

	return (
		<Stack sx={containerNextSX}>
			<Stack>
				<Box sx={containerTitleNextSX}>
					<DpRewardsCrown fill={'#ED2859'} background={'#E8E8E8'} />
					{title ? (
						<Typography component="h2" sx={titleSX}>
							{' '}
							{title}{' '}
						</Typography>
					) : null}
				</Box>
				{subtitles.length > 0 ? (
					<List sx={subtitleSX}>
						{subtitles.map((subtitle, index) => (
							<ListItem key={index} sx={listItemSX}>
								{subtitle}
							</ListItem>
						))}
					</List>
				) : null}
			</Stack>
		</Stack>
	);
};
